import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ASPECT_RATIOS } from "../../../utils/config.mjs";
var validVideoAspectRatios = [ASPECT_RATIOS.PORTRAIT, ASPECT_RATIOS.LANDSCAPE, ASPECT_RATIOS.SQUARE];
export var VideoPlayerSize = /*#__PURE__*/function (VideoPlayerSize) {
  VideoPlayerSize["SMALL"] = "sm";
  VideoPlayerSize["LARGE"] = "lg";
  return VideoPlayerSize;
}({});
export var DEFAULT_DIMENSIONS = _defineProperty(_defineProperty(_defineProperty({}, ASPECT_RATIOS.PORTRAIT, _defineProperty(_defineProperty({}, VideoPlayerSize.SMALL, {
  width: 150,
  height: 264
}), VideoPlayerSize.LARGE, {
  width: 270,
  height: 480
})), ASPECT_RATIOS.LANDSCAPE, _defineProperty(_defineProperty({}, VideoPlayerSize.SMALL, {
  width: 264,
  height: 150
}), VideoPlayerSize.LARGE, {
  width: 480,
  height: 270
})), ASPECT_RATIOS.SQUARE, _defineProperty(_defineProperty({}, VideoPlayerSize.SMALL, {
  width: 225,
  height: 225
}), VideoPlayerSize.LARGE, {
  width: 405,
  height: 405
}));
export var getVideoAspectRatio = function getVideoAspectRatio(aspectRatio, portrait) {
  if (aspectRatio && validVideoAspectRatios.includes(aspectRatio)) return aspectRatio;

  // Once portrait prop is deprecated, default to landscape
  return !!portrait ? ASPECT_RATIOS.PORTRAIT : ASPECT_RATIOS.LANDSCAPE;
};
export var parsePixelValue = function parsePixelValue(size) {
  if (!size) return null;
  var match = size.match(/^(\d+)px$/);
  return match ? parseInt(match[1], 10) : null;
};